export default __webpack_public_path__ + "static/media/psu-stidti-bold.8349ab23.ttf";